<template>
  <v-dialog :value="value" :width="defaultDialogWidth" @click:outside="close" persistent>
    <v-card class="text-center">
      <div class="px-4 py-4 text-center">
        <h5 class="title">Подтверждение</h5>
      </div>
      <p class="mb-1" v-if="!confirmMessage">Смс код отправлен на номер</p>
      <p class="mb-1" v-else>{{confirmMessage}}</p>
      <validation-observer v-slot="{handleSubmit}" ref="formObs">
        <form @submit.prevent="handleSubmit(confirm)">
          <v-card-text>
            <custom-input-text
              label="Код"
              vid="confirm"
              v-model="code"
              pattern="######"
              rules="required"
            ></custom-input-text>
            <time-interval ref="timeInterval" v-model="interval"></time-interval>
            <v-btn width="100%" v-if="interval <= 0" color="primary" @click="reSend" class="mb-3">Отправит еще</v-btn>
            <v-btn width="100%" :loading="loading" color="primary" type="submit">Подтвердить</v-btn>
          </v-card-text>
        </form>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
  import {defaultDialogWidth, messages} from "@/utils/constants";
  import TimeInterval from "@/components/sms/TimeInterval";

  export default {
    name: 'confirm-credit-dialog',
    components: {TimeInterval},
    props: {
      confirmMessage: {
        type: String
      },
      reSend: {
        type: Function,
        required: true
      },
      value: {},
      credit_id: {
        required: true
      },
      phone: {
        required: true
      }
    },
    data() {
      return {
        interval: 0,
        loading: false,
        code: '',
        defaultDialogWidth
      }
    },
    methods: {
      setTime() {
        this.$nextTick(() => {
          const {timeInterval} = this.$refs
          timeInterval.setTime()
        })
      },
      async confirm() {
        this.$showLoading()
        try {
          this.loading = true
          const {data: {data}} = await this.$http.post(`admin/credits/create/confirm/${this.credit_id}`, {
            code: this.code
          })
          this.$setSuccess({text: messages['onConfirmedCredit']})
          this.$emit('confirmed', data)
        } catch (e) {
          this.$setResponseError({error: e})
          this.$setFormError({error: e, obs: this.$refs['formObs']})
        } finally {
          this.loading = false
        }
        this.$clearLoading()
      },
      clearTime() {
        const {timeInterval} = this.$refs
        if (timeInterval) timeInterval.clearTime()
      },
      close() {
        this.$emit('input', false)
        this.clearTime()
      }
    },
    watch: {
      value(val) {
        if (!val) {
          const {formObs} = this.$refs
          this.code = ''
          this.loading = false
          this.clearTime()
          if (formObs) formObs.reset()
        }

      }
    }
  }
</script>